import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import {Typography} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
// import styles from '../inputFields/styles.js'; // Might not be needed
import "animate.css/animate.css";
import './styles/TagNumberFiels.css';

const TagNumberFielsEditable = (props) => {
  const minNum = props.minNum;
  const maxNum = props.maxNum;
  const [numValue, setNumValue] = useState("");
  const [tipText, setTipText] = useState(props.prompt);
  const [warningMsg, setWarningMsg] = useState('');
  const [error, setError] = useState(false);
  const [isUserTyping, setIsUserTyping] = useState(false);
  const isAlwaysOn = props.isAlwaysOn || false;
  const validationCase = props.validationCase || 'none';
  const isTagChecked = props.isTagChecked || false;

  // useEffect hooks for value processing, tipText, warningMsg, error (remain the same)
   useEffect(() => {
    // Don't overwrite user input while they're typing
    if (isUserTyping) return;

    const initialValue = props.value !== undefined && props.value !== null ? String(props.value) : "";
    let processedValue = initialValue;
     // ... processing logic ...
     if (initialValue !== "") {
        let num = parseFloat(initialValue);
        if (!isNaN(num)) {
            // Don't clamp on initial load - just display the value
            processedValue = String(num);
        } else {
            processedValue = "";
        }
    }
    setNumValue(processedValue);

    let newTipText = props.prompt || '';
    if (minNum !== undefined && maxNum !== undefined) {
      newTipText += ` Number must be between ${minNum} and ${maxNum}.`;
    } else if (minNum !== undefined) {
      newTipText += ` Number must be greater than or equal to ${minNum}.`;
    } else if (maxNum !== undefined) {
      newTipText += ` Number must be less than or equal to ${maxNum}.`;
    }
    setTipText(newTipText.trim());

  }, [props.value, minNum, maxNum, props.prompt, isUserTyping]);

  useEffect(() => {
    // ... warning logic ...
    if (numValue !== "") {
      const num = parseFloat(numValue);
      if (!isNaN(num)) {
        if (maxNum !== undefined && num > maxNum) setWarningMsg(`Number must be less than or equal to ${maxNum}`);
        else if (minNum !== undefined && num < minNum) setWarningMsg(`Number must be greater than or equal to ${minNum}`);
        else setWarningMsg('');
      } else {
        setWarningMsg('Invalid number');
      }
    } else {
      setWarningMsg('');
    }
  }, [numValue, minNum, maxNum]);

   useEffect(() => {
    let newError = false;
    // ... error logic ...
    if (validationCase === 'case_4') {
      // Case 4: Tag is required (alwaysOn), Variable Value is required
      if (props.required && isAlwaysOn) {
        if (numValue === "" || numValue === null || numValue === undefined) {
          newError = true;
        }
      }
    } else if (validationCase === 'case_2') {
      // Case 2: Tag is not required, but if tag is selected then the Variable is required
      if (props.required && isTagChecked) {
        if (numValue === "" || numValue === null || numValue === undefined) {
          newError = true;
        }
      }
    }
    setError(newError);
  }, [numValue, props.required, isAlwaysOn, validationCase, isTagChecked]);

  // handleChange, handleBlur, getHelperText (remain the same)
  const handleChange = (event) => {
    const currentVal = event.target.value;

    // Allow empty, minus sign, decimal point, or valid number patterns
    // This regex allows: "", "-", ".", "-.", and any valid number format
    if (currentVal === "" || /^-?\.?\d*\.?\d*$/.test(currentVal)) {
      setIsUserTyping(true);
      setNumValue(currentVal);
    } else {
      // Invalid character entered, don't update
      return;
    }

    let finalValueToPropagate;
    let isValid = true;

    if (currentVal === "" || currentVal === "-" || currentVal === "." || currentVal === "-.") {
      finalValueToPropagate = currentVal;

      // Check validity based on validation case
      if (validationCase === 'case_4' && props.required) {
        isValid = false;
      } else if (validationCase === 'case_2' && props.required && isTagChecked) {
        isValid = false;
      }
    } else {
      const num = parseFloat(currentVal);
      if (isNaN(num)) {
        finalValueToPropagate = currentVal;
        isValid = false;
      } else {
        finalValueToPropagate = num;
      }
    }

    props.onChange({
      name: props.param,
      value: finalValueToPropagate,
      isValid: isValid
    });
  };

  const handleBlur = (event) => {
    setIsUserTyping(false);
    let currentVal = event.target.value;
    let finalNum;
    let finalNumStr;

    if (currentVal.trim() === "" || currentVal === "-" || currentVal === "." || currentVal === "-.") {
      if (props.required && (validationCase === 'case_4' || (validationCase === 'case_2' && isTagChecked))) {
        finalNumStr = "";
        finalNum = undefined;
      } else {
        finalNum = 0;
        finalNumStr = "0";
      }
    } else {
      finalNum = parseFloat(currentVal);
      if (isNaN(finalNum)) {
        finalNumStr = (props.required && (validationCase === 'case_4' || (validationCase === 'case_2' && isTagChecked))) ? "" : "0";
        finalNum = parseFloat(finalNumStr);
      } else {
        if (minNum !== undefined && finalNum < minNum) finalNum = minNum;
        if (maxNum !== undefined && finalNum > maxNum) finalNum = maxNum;
        finalNumStr = String(finalNum);
      }
    }
    setNumValue(finalNumStr);

    let isValid = true;
    if (validationCase === 'case_4' && props.required && finalNumStr === "") {
      isValid = false;
    } else if (validationCase === 'case_2' && props.required && isTagChecked && finalNumStr === "") {
      isValid = false;
    }
    if (props.required && isNaN(finalNum) && finalNumStr !== "") isValid = false;

    props.onChange({
      name: props.param,
      value: finalNum,
      isValid: isValid
    });
  };

   const getHelperText = () => {
    // ... helper text logic ...
    if (error) {
      if (validationCase === 'case_4') {
        return "This field is required";
      } else if (validationCase === 'case_2') {
        return "This field is required if active";
      }
    }
    return warningMsg || "";
  };


  return (
    <Grid container className="tag-number-field-editable-container">
      <Grid item xs={12} sm={12}>
        <Tooltip title={tipText} placement="top" arrow>
          <TextField
            // className="tag-number-field-input" // Class might define height
            label={props.label}
            size="small" // Ensure size="small"
            variant={props.variant || "outlined"} // Use passed variant
            type="text"
            value={numValue}
            onChange={handleChange}
            onBlur={handleBlur}
            error={error}
            helperText={getHelperText()}
            inputProps={{
              inputMode: "decimal",
              tabIndex: props.tabIndex || 0
            }}
            InputProps={{
              // style: { height: '40px' }, // REMOVED explicit height
              classes: {
                  root: "tag-number-field-input" // Use this class if needed, but ensure height isn't set in CSS
              },
              endAdornment: null
            }}
          />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default TagNumberFielsEditable;